<template>
    <div class="resident-warpper">
        <div class="bg-white">
            <el-form :model="goodsForm" :rules="rules" ref="goodsForm" label-width="120px">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="社区：" prop="project" v-if="user.power === 3">
                            <el-select v-model="goodsForm.project" placeholder="请选择社区" style="width: 100%;">
                                <el-option
                                    v-for="item in projectList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="活动名称" prop="name">
                            <el-input v-model="goodsForm.name" placeholder="请输入活动名称"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="活动时间" prop="time">
<!--                            <el-input v-model="goodsForm.time" placeholder="请输入活动时间"></el-input>-->
                            <el-date-picker
                                v-model="goodsForm.time"
                                type="datetime"
                                placeholder="请选择活动时间"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                style="width: 100%;">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="活动地址" prop="address">
                            <el-input v-model="goodsForm.address" placeholder="请输入活动地址"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="活动人数" prop="number">
                            <el-input type="number" v-model="goodsForm.number" placeholder="请输入活动人数"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="活动积分" prop="points">
                            <el-input type="number" v-model="goodsForm.points" placeholder="请输入活动积分"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="活动类型" prop="type">
                            <el-select v-model="goodsForm.type" placeholder="请选择活动类型" style="width: 100%;">
                                <el-option
                                    v-for="item in types"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item label="活动介绍" prop="content">
                    <VueUditorWrap v-model="goodsForm.content" :config="myConfig"></VueUditorWrap>
                </el-form-item>

                <el-form-item class="flex align-center justify-around" label-width="0">
                    <el-button class="padding-lr-xl" type="primary" @click="submitForm('goodsForm')">保存</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import VueUditorWrap from 'vue-ueditor-wrap'
import {bdEditConfig} from "@/utils/utils";
import {getXiangMuList} from "@/api/common";
import {addActive, getActiveDetail} from "@/api/gzh";

export default {
    name: "shopping-add",
    data() {
        return {
            myConfig: bdEditConfig(),
            types: [
                {
                    value: 1,
                    label: '获得积分'
                },
                {
                    value: 2,
                    label: '扣除积分'
                }
            ],
            projectList: [],
            goodsForm: {
                project: '',
                name: '',
                time: '',
                address: '',
                number: '',
                points: '',
                type: '',
                content: '',
            },
            rules: {
                project: [{required: true, message: '请选择社区', trigger: 'blur'}],
                name: [{required: true, message: '请输入活动名称', trigger: 'blur'}],
                time: [{required: true, message: '请输入活动时间', trigger: 'blur'}],
                address: [{required: true, message: '请输入活动地址', trigger: 'blur'}],
                number: [{required: true, message: '请输入活动人数', trigger: 'blur'}],
                points: [{required: true, message: '请输入活动积分', trigger: 'blur'}],
                type: [{required: true, message: '请选择活动类型', trigger: 'blur'}],
                content: [{required: true, message: '请输入活动介绍', trigger: 'blur'}],
            },
            limit: 9,
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    components: {VueUditorWrap},
    created() {
        this.$emit("setIndex", '/home/gzh/active', "双暖为老 / 公众号管理 / 活动管理", true);
        if (Number(this.$route.params.id)) this.getDetail()
        this.getXiangMuList()
    },
    methods: {
        async getXiangMuList() {
            let _data = await getXiangMuList()
            this.projectList = _data.data
            if (this.user.power !== 3) {
                this.goodsForm.project = _data.data[0].id
            }
        },
        //  获取商品详情
        async getDetail() {
            let _data = await getActiveDetail(this.$route.params.id)
            this.goodsForm.project = _data.data.xiangmu_id
            this.goodsForm.name = _data.data.name
            this.goodsForm.time = _data.data.time
            this.goodsForm.address = _data.data.address
            this.goodsForm.number = _data.data.number
            this.goodsForm.points = _data.data.points
            this.goodsForm.type = _data.data.type
            this.goodsForm.content = _data.data.content
        },
        //  提交保存商品
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitData(formName)
                }
            });
        },
        async submitData(formName) {
            let _state = await addActive(
                this.goodsForm.project,
                this.goodsForm.name,
                this.goodsForm.time,
                this.goodsForm.address,
                this.goodsForm.number,
                this.goodsForm.points,
                this.goodsForm.type,
                this.goodsForm.content,
                this.$route.params.id ? this.$route.params.id : '',
            );
            this.$message.success(_state.info);
            this.$refs[formName].resetFields();
            this.$router.go(-1)
        }
    },
    filters: {},
    watch: {},
}
</script>

<style scoped lang="scss">

</style>
